import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useSearchParams } from "react-router-dom";
import Header from "../../../Components/adminDashboard/Header/Header";
import combinedServices from "../../../shared/services/user-service";
import CategoryComponent from "../../NambaStore/store/components/CategoryComponent";
import AttributeComponent from "../../NambaStore/store/components/AttributeComponent";
import ProductComponent from "../../NambaStore/store/components/ProductComponent";
import InventoryComponent from "../../NambaStore/store/components/InventoryComponent";
import OrderComponent from "../../NambaStore/store/components/OrderComponent";
import "../../NambaStore/store/storelist.css";
import "../CatagoryManagment/AdminNew.scss";
import NoticeBoard from "../../NambaStore/store/components/NoticeBoard";

const AdminStoreView = () => {
  const { storeId } = useParams();
  const navigate = useNavigate();
  const [storeData, setStoreData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("categoryList");
  const [searchParams, setSearchParams] = useSearchParams();

  // Category states
  const [categories, setCategories] = useState([]);
  const [totalCategories, setTotalCategories] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteStatus, setdeleteStatus] = useState();

  // Attribute states
  const [attributes, setattributes] = useState([]);
  const [totalattributes, setTotalattributes] = useState(0);
  const [attributepage, setattributePage] = useState(1);
  const [attributelimit, setattributeLimit] = useState(10);
  const [attributesearchQuery, setattributeSearchQuery] = useState("");
  const [attributedeleteStatus, setattributedeleteStatus] = useState();

  useEffect(() => {
    const fetchStoreData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await combinedServices.getstorebyid(storeId);
        if (response?.data?.data) {
          const store = response.data.data;
          const urlTab = searchParams.get('tab');
          if (urlTab) {
            setActiveTab(urlTab);
            searchParams.delete('tab');
            setSearchParams(searchParams, { replace: true });
          }
          const safeJsonParse = (jsonString, fallback = []) => {
            if (!jsonString) return fallback;
            if (Array.isArray(jsonString)) return jsonString;
            try {
              return JSON.parse(jsonString);
            } catch (e) {
              console.warn("Failed to parse JSON:", jsonString);
              return fallback;
            }
          };

          // Parse JSON fields safely
          const parsedStore = {
            ...store,
            storeimage: safeJsonParse(store.storeimage, []),
            district: safeJsonParse(store.district, []),
            storeadmins: safeJsonParse(store.storeadmins, []),
          };
          setStoreData(parsedStore);
        }
      } catch (err) {
        setError("Failed to fetch store data. Please try again later.");
        console.error("Error fetching store:", err);
      } finally {
        setLoading(false);
      }
    };

    if (storeId) {
      fetchStoreData();
    }
  }, [storeId]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const formatDistricts = (districts) => {
    if (!districts || !Array.isArray(districts)) return "";
    return districts.map((id) => `D${id}`).join(", ");
  };

  const formatAdminNames = (admins) => {
    if (!admins || !Array.isArray(admins)) return "";
    return admins
      .map((admin) => `${admin.firstname} ${admin.lastname}`)
      .join(", ");
  };

  if (loading) {
    return (
      <div className="store-page">
        <Header />
        <div className="dbRight">
          <section className="dbMid dbInner">
            <div className="loading-indicator">Loading store data...</div>
          </section>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="store-page">
        <Header />
        <div className="dbRight">
          <section className="dbMid dbInner">
            <div className="error-message">{error}</div>
          </section>
        </div>
      </div>
    );
  }

  if (!storeData) {
    return (
      <div className="store-page">
        <Header />
        <div className="dbRight">
          <section className="dbMid dbInner">
            <div className="empty-message">Store not found.</div>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="store-page">
      <Header />
      <div className="dbRight">
        <section className="dbMid dbInner">
          <div className="container-fluid">
            <div className="row" style={{marginLeft:"50px"}}>
              <div className="col-lg-12 store-list-container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h1 className="store-list-title">Store - {storeData.storename}</h1>
                  <button className="nambaBtn" onClick={() => navigate("/storelist")}>
                    Back to Store List
                  </button>
                </div>

                <div className="d-flex flex-wrap productList p-0 mb-4">
                  <div className="store-card-wrapper selected" style={{ flex: '1 1 100%' }}>
                    <div className="inner d-flex align-items-center">
                      <div className="img">
                        <img
                          src={
                            storeData.storeimage[0] ||
                            "https://via.placeholder.com/250x150?text=No+Image"
                          }
                          alt={storeData.storename}
                          className="store-image"
                        />
                      </div>
                      <div className="name ms-3">
                        {storeData.storename}
                        <div className="pt-1">
                          <span className="store-districts">
                            Districts: {formatDistricts(storeData.district)}
                          </span>
                        </div>
                        <div className="pt-1">
                          <span className="store-districts">
                            Admins: {formatAdminNames(storeData.storeadmins)}
                          </span>
                        </div>
                        <div className="pt-1">
                          <span className="store-districts">
                            Status: {storeData.isAvailable ? "Active" : "Inactive"}
                          </span>
                        </div>
                        <div className="pt-1">
                          <span className="store-districts">
                            Created: {new Date(storeData.createdOn).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ul className="d-flex flex-wrap storeTabs">
                  <li>
                    <a
                      className={activeTab === "categoryList" ? "active" : ""}
                      onClick={() => handleTabClick("categoryList")}
                    >
                      Category List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "attributeList" ? "active" : ""}
                      onClick={() => handleTabClick("attributeList")}
                    >
                      Attribute List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "productList" ? "active" : ""}
                      onClick={() => handleTabClick("productList")}
                    >
                      Product List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "inventoryList" ? "active" : ""}
                      onClick={() => handleTabClick("inventoryList")}
                    >
                      Inventory List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "orderList" ? "active" : ""}
                      onClick={() => handleTabClick("orderList")}
                    >
                      Order List
                    </a>
                  </li>
                  <li>
                    <a
                      className={activeTab === "noticeBoard" ? "active" : ""}
                      onClick={() => handleTabClick("noticeBoard")}
                    >
                      Notice Board
                    </a>
                  </li>
                </ul>

                <div className="storeTable mt-4">
            {activeTab === "categoryList" && (
              <CategoryComponent
                storeID={storeId}
                page={page}
                limit={limit}
                searchQuery={searchQuery}
                setPage={setPage}
                setLimit={setLimit}
                setSearchQuery={setSearchQuery}
                categories={categories}
                setCategories={setCategories}
                totalCategories={totalCategories}
                setTotalCategories={setTotalCategories}
                deleteStatus={deleteStatus}
                setdeleteStatus={setdeleteStatus}
                adminstoreview={true}
              />
            )}

            {activeTab === "attributeList" && (
              <AttributeComponent
                storeID={storeId}
                attributes={attributes}
                setattributes={setattributes}
                totalattributes={totalattributes}
                setTotalattributes={setTotalattributes}
                attributepage={attributepage}
                setattributePage={setattributePage}
                attributelimit={attributelimit}
                setattributeLimit={setattributeLimit}
                attributesearchQuery={attributesearchQuery}
                setattributeSearchQuery={setattributeSearchQuery}
                attributedeleteStatus={attributedeleteStatus}
                setattributedeleteStatus={setattributedeleteStatus}
                adminstoreview={true}
              />
            )}

            {activeTab === "productList" && (
              <ProductComponent
                storeID={storeId}
                page={page}
                limit={limit}
                searchQuery={searchQuery}
                setPage={setPage}
                setLimit={setLimit}
                setSearchQuery={setSearchQuery}
                adminstoreview={true}
              />
            )}

            {activeTab === "inventoryList" && (
              <InventoryComponent
                storeID={storeId}
                page={page}
                limit={limit}
                searchQuery={searchQuery}
                setPage={setPage}
                setLimit={setLimit}
                setSearchQuery={setSearchQuery}
              />
            )}

                  {activeTab === "orderList" && (
                    <OrderComponent
                      storeID={storeId}
                      storeName={storeData.storename}
                      page={page}
                      limit={limit}
                      searchQuery={searchQuery}
                      setPage={setPage}
                      setLimit={setLimit}
                      setSearchQuery={setSearchQuery}
                    />
                  )}
                    {activeTab==="noticeBoard" && (
                      <NoticeBoard
                      storeId={storeId}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminStoreView;
